import { getReturnOrdersSetup, getReturnOrders, deleteReturnOrdersDetails } from '@/services/suppliers.js'
import jsonData from './jsonData.js'
import allButton from '@/components/allButton'
import searchForm from '@/components/searchForm'
import createTable from '@/components/createTable'
import dialogEffect from '@/components/dialogEffect'
import { mixin } from '@/mixins/mixin'
export default {
  name: 'SupplierList',
  mixins: [mixin],
  components: {
    searchForm,
    createTable,
    allButton,
    dialogEffect
  },
  data () {
    return {
      tableDataItem: jsonData.tableDataItem,
      isTabChange: false
    }
  },
  watch: {
    $route (to, from) {
      // console.log(from)
      // if (from.name === 'managerUserOrderView') {
      //   this.$nextTick(() => {
      //     this.search()
      //     this.$refs.createTable.$refs.table.doLayout()
      //   })
      // }
    }
  },
  created () {
    this.queryData(getReturnOrdersSetup)
  },
  activated () {
    if (this.isActive) this.queryData(getReturnOrdersSetup)
    this.isActive = true
  },
  methods: {
    // 点击操作按钮
    async handleClick (type, data) {
      if (type === 'create') {
        this.$router.push({
          name: 'returnOrderAdd'
        })
      }
      if (type?.action === 'view') {
        this.$router.push({
          name: 'returnOrderDetail',
          params: {
            id: data.id.value
          }
        })
      }
      if (type?.action === 'create') {
        this.$router.push({
          name: 'returnOrderAdd'
        })
      }
      if (type?.action === 'edit') {
        this.$router.push({
          name: 'returnOrderEdit',
          params: {
            id: data.id.value
          }
        })
      }
      if (type?.action === 'destroy') {
        this.deleteClick(data, deleteReturnOrdersDetails)
      }
    },
    handleSwitchChange (data) {},
    forwardToPage (data, name) {
      if (name === 'supplier') {
        this.$router.push({
          name: 'suppliersDetail',
          params: {
            id: data.id
          }
        })
      }
    },
    tabChange (index) {
      this.isTabChange = true
      const params = {
        scope: this.tabData[index].value
      }
      this.queryData(getReturnOrdersSetup, params)
    },
    // 查询
    search (data) {
      if (this.isTabChange) {
        this.isTabChange = false
        return
      }
      if (data) this.searchData = data
      const { page, per_page } = this.pageData
      Object.assign(this.searchData, { page, per_page })
      this.loading = true
      getReturnOrders(this.searchData).then(res => {
        if (res.data) {
          this.tableData = res.data.objects
          this.tabData = res.data.scopes
          Object.assign(this.pageData, res.data.pagination)
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
